module.exports = __webpack_public_path__ + "img/Akiva2021.7591df64.png";